import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { NavLink, useLocation } from 'react-router-dom';
import Select from "react-select";
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import { formatDateWithTime ,decodeUrl,encodeData, decodeData, currentDateAndTime} from '../../Constants/constants';
import { SubmitButton } from '../../Components/InputElements';


function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const PayrollHeadMaster = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions } = useContext(ConfigContext);
    const query = useQuery();
    const encodedData = query.get("abs");
    const decodedDataId = decodeUrl(encodedData);
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

    const [title, setTitle] = useState(query.get("title"));
    const [headType, setHeadType] = useState(query.get("type"));
    const [paramPage, setParamPage] = useState(query.get("page"));
    const [paramLimit, setParamLimit] = useState(query.get("limit"));
    const [rows, setRows] = useState([]);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: parseInt(paramPage) || 1,
        total_records: "",
        total_pages: "",
        limit: parseInt(paramLimit) || 10,
    });
    const [filter, setFilter] = useState({
        keyword: null,
        checkHeadType: null,
    });
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [loadingList, setLoadingList] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [clearAction, setClearAction] = useState(false);
    const [limitAction, setLimitAction] = useState(false);
    const [toggleButton, setToggleButton] = useState(false);
    const limitOptions = [10, 25, 50, 100, 200, 500];

    const getList = async () => {
        const headers = apiHeaderJSON;
        console.log(paramLimit,paramPage);
        axios.get(`${apiURL}Payrolls/GetSalaryHeadList`, {
            params: {
                limit: parseInt(paramLimit) || pagination?.limit,
                page: parseInt(paramPage) || pagination?.page,
                keyword: filter?.keyword || title,
                checkHeadType: filter?.checkHeadType || headType,
            }, headers
        }).then((response) => {

            let data = response.data;
            console.log(response?.data);
            if (response.data.success === true) {

                setRows(data?.result?.data);
                setPagination({
                    ...pagination,
                    next: data?.result?.next,
                    prev: data?.result?.prev,
                    page: data?.result?.page,
                    total_records: data?.result?.total_records,
                    total_pages: data?.result?.total_pages,
                });

            }
            setLoadingList(false);
            setLoadingSearch(false);
            setLoadingFilter(false);
        }).catch(function (error) {
            setLoadingSearch(false);
            setLoadingList(false);
            setLoadingFilter(false);
            console.log("error", error);
        });
    }

    const handleExcelDownload = () => {
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios
            .get(`${apiURL}Payrolls/GetSalaryHeadList`, {
                params: {
                    limit: paramLimit || pagination?.limit,
                    page: paramPage || pagination?.page,
                    keyword: filter?.keyword || title,
                    checkHeadType: filter?.checkHeadType || headType,
                    export_data: true,
                    date: currentDateAndTime(),
                }, headers
            }).then((response) => {
                if (response.data.success === true) {
                    let res = response.data;
                    let rows = res?.result?.data;

                    const data = rows.map(row => ({
                        'Salary Head': row.company_salary_head,
                        'Head Type': row.salary_head_type,
                        'Frequency': row.calculation_frequency,
                        'Calculations On': row.calculation_mode_name,
                    }));

                    const columns = [
                        { header: 'Salary Head', key: 'Salary Head', width: 30 },
                        { header: 'Head Type', key: 'Head Type', width: 30 },
                        { header: 'Frequency', key: 'Frequency', width: 30 },
                        { header: 'Calculations On', key: 'Calculations On', width: 30 },
                    ];


                    const wb = XLSX.utils.book_new();

                    const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });

                    ws['!cols'] = columns.map(column => ({ wch: column.width }));

                    XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });

                    columns.forEach((column, index) => {
                        ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                    });

                    XLSX.utils.book_append_sheet(wb, ws, 'Salary Head');

                    // XLSX.writeFile(wb, `AbStartTeamAttendanceReport_(${Date()}).xlsx`);

                    const date = new Date();

                    XLSX.writeFile(wb, `Salary Head (${formatDateWithTime()?.split(" ")[0]}).xlsx`);

                    Swal.close();

                    Swal.fire({
                        title: '<strong>Success</strong>',
                        html: 'Your file has been downloaded successfully.',
                        icon: 'success',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    });
                } else {
                    Swal.close();
                    Swal.fire({
                        title: '<strong>Error</strong>',
                        html: response.data.message,
                        icon: 'error',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    });
                }
                setLoadingDownload(false);
            })
            .catch((error) => {
                setLoadingDownload(false);
                Swal.close();
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            });
    }

    useEffect(() => {
        setLoadingList(true);
        console.log("title, headType", title, headType);
        setFilter({
            ...filter,
            keyword: title || "",
            checkHeadType: headType || "",
        });
        setPagination({
            ...pagination,
            page: parseInt(paramPage) || 1,
            limit: parseInt(paramLimit) || 10,
        })
        getList();
    }, []);

    useEffect(() => {
        if (clearAction) {
            getList();
            setClearAction(false);
        }
        if (limitAction) {
            getList();
            setLimitAction(false);
        }
    }, [clearAction,limitAction]);


    const handleLimitChange = (e) => {
        console.log(e.target.value);
        setPagination(
            {
                ...pagination,
                limit: e.target.value,
                page: 1,
            });
        setParamLimit(e.target.value);
        setParamPage(1)
        setLimitAction(true);
    };
    const handlePageChange = (e) => {
        console.log(e.target.value);
        setPagination(
            {
                ...pagination,
                page: parseInt(e.target.value),
            });
        setParamPage(parseInt(e.target.value));
        setLimitAction(true);
    };

    const handleToggleSwitch = (company_salary_head_id, toggleButton) => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to change head status to ${toggleButton ? "On" : "Off"}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    company_salary_head_id: company_salary_head_id,
                    activated: toggleButton ? 1 : 2,
                    date: currentDateAndTime(),
                }
                const headers = apiHeaderJSON;
                setToggleButton(!toggleButton);
                console.log(data);
                axios
                    .post(`${apiURL}Payrolls/HandleHeadActivation`, data, {
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleToggleSwitch ~ response =======>>>", response);
                        if (success === true) {
                            setSuccessMsg(response.data.message);
                            setErrorMsg(false);
                            getList(false);
                        } else {
                            setSuccessMsg(false);
                            setErrorMsg(response.data.message);
                        }
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }

    const handleInputSearch = (e) => {
        getList();
    }

    const handleClearAll = (e) => {
        setFilter({
            keyword: "",
            checkHeadType: "",
        });
        setTitle("");
        setHeadType('');
        const url = window.location.origin + `/PayrollHeadMaster?abs=${encodedData}`;
        window.history.replaceState(null, '', url);
        setClearAction(true);

    }
    function removeQueryParam(param) {
        const url = window.location.href;
        let urlObj = new URL(url);
        urlObj.searchParams.delete(param);
        window.history.replaceState(null, '', urlObj.toString());
        setClearAction(true);
        return urlObj.toString();
    }
    const handleInputChange = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value,
        });
        if(!e.target.value){
            removeQueryParam("title");
        }
    };

    const handleChange = (name, value) => {
        setFilter({ ...filter, [name]: value });
    }
    const handleChanged = (type) => {
        setPagination({
          ...pagination,
          page: parseInt(type.target.value),
        });
        setLimitAction(true);
    }

    const handleDelete = (company_salary_head_id) => {
        const headers = apiHeaderJSON;
        Swal.fire({
            title: 'Are you sure?',
            text: "Once deleted, you will not be able to recover this item!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    company_salary_head_id: company_salary_head_id,
                    date: currentDateAndTime(),
                };
                // console.log("delete handle called");
                axios
                    .post(`${apiURL}Payrolls/DeleteSalaryHead`, data, {
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleDelete ~ response =======>>>", response);
                        if (success === true) {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false,  // Show OK button
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    getList();
                                }
                            });

                        } else {

                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false,  // Show OK button
                            }).then((result) => {
                                if (result.isConfirmed) {

                                }
                            });

                        }
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled Delete..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });
        // Swal({
        //     title: "Are you sure?",
        //     text: "Once deleted, you will not be able to recover this item!",
        //     icon: "warning",
        //     buttons: true,
        //     dangerMode: true,
        // }).then((willDelete) => {
        //     if (willDelete) {
        //         let data = {
        //             company_salary_head_id: company_salary_head_id,
        //         };
        //         const headers = apiHeaderJSON;
        //         console.log(data);


        //     }  
        // });
    }
    const handlePrev = () => {
        console.log(pagination?.prev)
        if (pagination?.prev === true) {
            console.log(pagination?.page - 1)
            setPagination({
                ...pagination,
                page: pagination?.page - 1,
            });
        }
        setLimitAction(true);
    }
    const handleNext = () => {
        console.log(pagination?.next)
        if (pagination?.next === true) {
            console.log(pagination?.page + 1)
            setPagination({
                ...pagination,
                page: pagination?.page + 1,
            });
        }
        setLimitAction(true);
    }

    const handleSubmit = () => {

    }
    const headOptions = [
        { value: "Fixed Component", label: "Fixed Component" },
        { value: "Earning", label: "Earning" },
        { value: "EE Statutory Deduction", label: "EE Statutory Deduction" },
        { value: "ER Statutory Contribution", label: "ER Statutory Contribution" },
        { value: "Other Earnings", label: "Other Earnings" },
        { value: "Other Deductions", label: "Other Deductions" },
    ];
    return (
        <>
        {!loadingList? (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Payroll Head Master`} primary={`Home`} />

                        {/* <div className="row">
                            <div className="col-md-12"> */}
                                <div className="card">
                                    <div className="card-body">
                                        <div className="card-header pt-0 align-items-center d-flex">
                                            <h4 className="card-title mb-0 flex-grow-1">Payroll Head</h4>
                                            { decodedData?.includes(2) && ( 
                                            <NavLink to={`/CreatePayrollHead?abs=${encodeData(decodedDataId)}${filter?.keyword && filter?.checkHeadType ? `&title=${filter?.keyword}&type=${filter?.checkHeadType}` : filter?.keyword ? `&title=${filter?.keyword}` : filter?.checkHeadType ? `&type=${filter?.checkHeadType}` : ""}${(filter?.keyword || filter?.checkHeadType) && (pagination.page != 1 || pagination.limit != 10) ? `&page=${pagination.page}&limit=${pagination.limit}`: (pagination.page != 1 || pagination.limit != 10)? `&page=${pagination.page}&limit=${pagination.limit}` : ""}` } className="btn btn-success" >Add Payroll Head</NavLink >)}
                                        </div>
                                        <div className="card-header">
                                            <div className="row">
                                                <div className='col-md-3'>
                                                    <label htmlFor="keyword">Head Title</label>
                                                    <div className="input-group">
                                                        <input type="search" className="form-control" 
                                                        onChange={handleInputChange} 
                                                        name="keyword" value={filter?.keyword} 
                                                        aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Enter Title" />
                                                        <button className="btn btn-success" 
                                                        onClick={()=>{
                                                            if(!loadingSearch){
                                                                setLoadingSearch(true);
                                                                handleInputSearch();
                                                            }
                                                        }} 
                                                        type="button" id="button-addon2">
                                                        {loadingSearch ? (
                                                        <span
                                                            class="spinner-border flex-shrink-0"
                                                            role="status"
                                                            style={{
                                                            width: "0.8rem",
                                                            height: "0.8rem",
                                                            borderWidth: "2px",
                                                            }}
                                                        >
                                                            <span class="visually-hidden">Loading...</span>
                                                        </span>
                                                        ) : (
                                                            <i className="ri-search-line"></i>)
                                                        }</button>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className=' position-relative' >
                                                        <div className=' position-absolute z-2 w-100' >
                                                        <div>
                                                            <label>Head Type</label>
                                                        </div>
                                                        <Select
                                                            options={headOptions}
                                                            value={filter?.checkHeadType ? headOptions.find(option => option.value == filter?.checkHeadType) : null}
                                                            onChange={(selectedOption) => handleChange('checkHeadType', selectedOption?.value)}
                                                            placeholder={`Select Head Type`}
                                                        />
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <div>
                                                                <label className=' noWrap'>Apply Filter</label>
                                                            </div>
                                                            {/* <button
                                                                type="button"
                                                                onClick={handleInputSearch}
                                                                disabled={!filter?.checkHeadType}
                                                                className={`btn btn-info btn-label waves-effect waves-light`}>
                                                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                                Filter
                                                            </button> */}
                                                            <SubmitButton onClick={(e)=>{ 
                                                                if(!loadingFilter){
                                                                    setLoadingFilter("1");
                                                                    handleInputSearch();
                                                                }
                                                            }}
                                                            loading={loadingFilter==="1"} otherClasses='w-100' disabled={!filter?.checkHeadType || loadingFilter} 
                                                            loadingMessage='Loading' buttonName={'Filter'} icon={'ri-filter-3-fill'} 
                                                            type='info' iconSide='left' />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div>
                                                                <label className=' noWrap'>Clear Filter</label>
                                                            </div>
                                                            {/* <button
                                                                type="button"
                                                                disabled={!filter?.checkHeadType && !filter?.keyword}
                                                                className={`btn btn-secondary btn-label waves-effect waves-light noWrap`}
                                                                onClick={handleClearAll}
                                                            >
                                                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Clear
                                                                </button> */}
                                                            <SubmitButton onClick={(e)=>{ 
                                                                if(!loadingFilter){
                                                                    setLoadingFilter("2");
                                                                    handleClearAll();
                                                                }
                                                            }}
                                                            loading={loadingFilter==="2"} otherClasses='w-100' disabled={!filter?.checkHeadType || loadingFilter} 
                                                            loadingMessage='Loading' buttonName={'Clear'} icon={'ri-database-2-line'} 
                                                            type='secondary' iconSide='left' />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className='row'>
                                                        { decodedData?.includes(6) && ( 
                                                        <div className='col-md-6'>
                                                            <div>
                                                                <label className=' noWrap'>Excel Export</label>
                                                            </div>
                                                            {/* <button
                                                                type="button"
                                                                disabled={rows?.length===0}
                                                                className={`btn noWrap btn-success btn-label waves-effect waves-light noWrap`}
                                                                onClick={handleExcelDownload}
                                                            >
                                                                <i className=" ri-file-excel-2-line label-icon align-middle fs-16 me-2"></i> Export
                                                                </button> */}
                                                            <SubmitButton onClick={(e)=>{ 
                                                                    if(!loadingDownload){
                                                                        setLoadingDownload(true);
                                                                        handleExcelDownload();
                                                                    }
                                                                }}
                                                                loading={loadingDownload} otherClasses='w-100 noWrap' disabled={rows?.length===0} 
                                                                loadingMessage='Export' buttonName={'Export'} icon={'ri-file-excel-2-line'} 
                                                                type='success' iconSide='left' />
                                                        </div>)}
                                                        { decodedData?.includes(3) && ( 
                                                        <div className='col-md-6'>
                                                            <div>
                                                                <label className=' noWrap'>Change Heads Order</label>
                                                            </div>
                                                            <NavLink className="btn btn-primary btn-label waves-effect waves-light noWrap" 
                                                            to={`/PayrollHeadOrderEdit?abs=${encodeData(decodedDataId)}${filter?.keyword && filter?.checkHeadType ? `&title=${filter?.keyword}&type=${filter?.checkHeadType}` : filter?.keyword ? `&title=${filter?.keyword}` : filter?.checkHeadType ? `&type=${filter?.checkHeadType}` : ""}${(filter?.keyword || filter?.checkHeadType) && (pagination.page != 1 || pagination.limit != 10) ? `&page=${pagination.page}&limit=${pagination.limit}`: (pagination.page != 1 || pagination.limit != 10)? `&page=${pagination.page}&limit=${pagination.limit}` : ""}`}>
                                                                <i className="bx bx-list-ul label-icon align-middle fs-4 " /> Edit Order
                                                            </NavLink>
                                                            {/* <button
                                                                type="button"
                                                                disabled={!filter?.checkHeadType && !filter?.keyword}
                                                                className={`btn btn-secondary btn-label waves-effect waves-light noWrap`}
                                                            >
                                                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Edit Order</button> */}
                                                        </div>)}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div style={{ "maxHeight": "65vh", "overflowY": "auto",}}>
                                            <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative" style={{ width: "100%" }}>
                                                <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                                    <tr>
                                                        <th className=' text-center'>Sr.No.</th>
                                                        <th width={`30%`}>Head Title</th>
                                                        <th width={`20%`}>Head Type</th>
                                                        <th width={`20%`}>Frequency</th>
                                                        <th width={`10%`}>Calculation</th>
                                                        <th width={`10%`}>Created</th>
                                                        { decodedData?.includes(3) && ( 
                                                        <th className=' text-center'>Status</th>)}
                                                        { (decodedData?.includes(3) || decodedData?.includes(4)) && ( 
                                                        <th width={`30%`} className=' text-center'>Action</th>)}
                                                    </tr>
                                                </thead>
                                                {
                                                    !loadingList ?
                                                        rows?.length == 0 ?
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={12}>
                                                                        <NoRecords />
                                                                    </td>
                                                                </tr>
                                                            </tbody> :
                                                            <tbody>
                                                                {
                                                                    rows?.length > 0 && rows?.map((row, idx) => {
                                                                        return <tr key={row.company_salary_head_id}>
                                                                            <td className=' text-center'>{idx + 1}</td>
                                                                            <td>{row.company_salary_head}</td>
                                                                            <td>{row.salary_head_type}</td>
                                                                            <td>{row.calculation_frequency}</td>
                                                                            <td>{row.calculation_mode_name}</td>
                                                                            <td>{row.is_editable==="0"? "Auto":"Manual"}</td>
                                                                            { decodedData?.includes(3) && ( 
                                                                            <td>
                                                                                <div>
                                                                                    <ToggleSwitch isActive={row?.activated === 1 ? true : false} isExtFunc={true} onToggle={() => { handleToggleSwitch(row.company_salary_head_id, row?.activated === 1 ? false : true) }} />
                                                                                </div>
                                                                            </td>)}
                                                                            { (decodedData?.includes(3) || decodedData?.includes(4)) && ( 
                                                                            <td >
                                                                                <div className='d-flex justify-content-around'>
                                                                                    { decodedData?.includes(3) && ( 
                                                                                    <NavLink to={`/CreatePayrollHead?abs=${encodeData(decodedDataId)}&id=${row.company_salary_head_id}${filter?.keyword ? `&title=${filter?.keyword}` : ''}${filter?.checkHeadType ? `&type=${filter?.checkHeadType}` : ""}${(row.company_salary_head_id || filter?.keyword || filter?.checkHeadType) && (pagination.page != 1 || pagination.limit != 10) ? `&page=${pagination.page}&limit=${pagination.limit}`: (pagination.page != 1 || pagination.limit != 10)? `?page=${pagination.page}&limit=${pagination.limit}` : ""}`} type='button' className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </NavLink>)}
                                                                                    { decodedData?.includes(4) && ( 
                                                                                        <button onClick={() => handleDelete(row.company_salary_head_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                                                    {/*<button onClick={() => setCompanyInfo({ company_salary_head_id: row.company_salary_head_id })} className="btn-icon btn btn-sm btn-outline-success" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="ri-file-info-line"></i> </button> */}
                                                                                </div>
                                                                            </td>)}
                                                                        </tr>
                                                                    })

                                                                }
                                                            </tbody>:
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={12}>
                                                                        <div className="text-center mt-3">
                                                                            <span className="text-info"><i className="mdi mdi-loading mdi-spin fs-1 align-middle me-2" /> Loading.....</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                }

                                                {/* <tfoot className='table-light sticky-bottom z-1'>
                                                    <tr>
                                                        <th colSpan={8} >
                                                            <div className="d-flex justify-content-between" >
                                                                <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {
                                                                        <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                                                    }
                                                                </div>
                                                                <div className='col-md-2'>
                                                                    <select className="form-select" onChange={(e) => { handlePageChange(e) }}>
                                                                        {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                                            <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <select
                                                                        className="form-select"
                                                                        onChange={handleLimitChange}
                                                                        value={pagination?.limit}
                                                                    >
                                                                        {limitOptions.map((option) => (
                                                                            <option key={option} value={option}>
                                                                                Limit {option}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </tfoot> */}

                                            </table>
                                        </div>
                                        <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                            <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                {
                                                    <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                                }
                                            </div>
                                            <div className='col-md-2'>
                                                <select className="form-select" onChange={(e) => handleChanged(e)}>
                                                    {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                        <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                                    {pagination?.total_records >= 1 && (
                                                        <option value={pagination?.total_records}>
                                                            All
                                                        </option>
                                                    )}
                                                    {limitOptions?.map((option) => (
                                                        <option key={option} value={option}>
                                                            Limit {option}
                                                        </option>
                                                    ))}
                                                    
                                                </select>
                                            </div>
                                            <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        {/* </div>
                    </div> */}
                </div>
            </div>
        ) : (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "90vh" }}
            >
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
           </div>
        )}
        </>
        
    );
}

export default PayrollHeadMaster;

